import { ReactNode } from 'react';

export type TFurtherPeriodNotifierContext = 'check' | 'address' | 'datetime' | 'orderData' | 'finale';

/**
 * @description границы цикла доп. заказа в формате DD.MM
 */
export type TFurtherPeriodDates = {
    start: string;
    end: string;
};

const furtherPeriodNotifierBaseTexts: Record<'check' | 'address', string> = {
    check: 'Оплата заказа на Хэллоуин — через ЛК или курьеру по QR-коду.',
    address: 'Заказ на Хэллоуин будет доставлен на тот же адрес. Это можно поменять в ЛК.',
};

export const getFurtherPeriodNotifierText = (
    context: TFurtherPeriodNotifierContext,
    { start, end }: TFurtherPeriodDates,
): ReactNode => {
    if (context === 'check' || context === 'address') {
        return furtherPeriodNotifierBaseTexts[context];
    }

    if (context === 'finale') {
        return `Заказ на Хэллоуин будет доставлен на неделе с ${start} до ${end}, по тому же адресу.
         Адрес и дату доставки можно поменять через ЛК.`;
    }

    return `Заказ на Хэллоуин будет доставлен на неделе с ${start} до ${end}. Точную дату и время доставки можно поменять в ЛК.`;
};
